import { useTranslation } from 'react-i18next'

import Icon from '../../../ui/Icon'
import { Button } from '../../../buttons/Button'
import { CourtSvg } from '../../../ui/courtSvg/CourtSvg'

import { CourtModel, CourtType } from '../../../../types/court/court'
import { formatMinutes } from '../../../../utils/booking/booking'

type GuestCourtCardProps = {
  court: CourtModel
  onBook: () => void
}

/** One court of a club: its surface colour, type, lighting and session lengths, with a direct booking action. */
export const GuestCourtCard = ({ court, onBook }: GuestCourtCardProps) => {
  const { t } = useTranslation(['clubs', 'courts'])
  const isIndoor = court.courtType === CourtType.INDOOR
  const durations = [...(court.club?.sessionDurations ?? [])].sort((a, b) => a - b)

  return (
    <article className={`guest-court-card ${isIndoor ? 'is-indoor' : 'is-outdoor'}`}>
      <div className="guest-court-preview" aria-hidden="true">
        <CourtSvg indoor={isIndoor} w={78} h={138} />
      </div>

      <div className="guest-court-body">
        <div className="guest-court-topline">
          <h3 className="guest-court-name">{court.name}</h3>
          <span className="guest-court-type">
            <Icon name={isIndoor ? CourtType.INDOOR : CourtType.OUTDOOR} size={12} />
            {t(`courts:courts.type.${court.courtType}`)}
          </span>
        </div>

        {court.notes && <p className="guest-court-note">{court.notes}</p>}

        <div className="guest-court-tags">
          {durations.map(duration => (
            <span key={duration} className="guest-court-tag mono">
              {formatMinutes(duration)}
            </span>
          ))}
          {court.lightSwitchName && (
            <span className="guest-court-tag is-light">
              <Icon name="moon" size={12} />
              {t('clubs:clubs.guest.lighting')}
            </span>
          )}
        </div>

        <Button
          className="guest-court-book"
          variant="ghost"
          size="sm"
          label={t('clubs:clubs.guest.book-court')}
          icon={<Icon name="arrowR" size={14} />}
          iconPosition="right"
          onClick={onBook}
        />
      </div>
    </article>
  )
}
